export const radii = {
  md: '8px',
  lg: '20px',
  round: '50%',
}
